import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFind } from 'src/api/APIHooks';
import Notifier from 'common/helpers/Notifier';
import AddCaseDetailsForm from '../../components/Cases/components/AddCaseDetailsForm';

function AddCaseDetailsFormContainer(props) {
  const { contactId } = props;

  const {
    data: clientNeedsData,
    isLoading: isClientNeedsLoading,
    error: clientNeedsError,
  } = useFind(
    `people/${contactId}/person_conditions`,
    { most_recent: true },
    {
      queryConfig: {
        placeholderData: undefined,
        // A query that never succeeded refetches on mount, window focus and reconnect, and each refetch
        // clears its error and hides the section. Keep the failed state until the page is reloaded.
        retryOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
      },
    },
  );

  useEffect(() => {
    if (clientNeedsError) {
      Notifier.dispatch(
        'error',
        'Associated needs could not be loaded due to a network error. ' +
          'Please refresh the page and try again. By refreshing the page, your data will be lost.',
      );
    }
  }, [clientNeedsError]);

  return (
    <AddCaseDetailsForm
      {...props}
      clientNeedsFromQuery={clientNeedsData?.data?.data || []}
      isClientNeedsLoading={isClientNeedsLoading}
      clientNeedsError={clientNeedsError}
    />
  );
}

AddCaseDetailsFormContainer.propTypes = {
  contactId: PropTypes.string.isRequired,
};

export default AddCaseDetailsFormContainer;
